import { render, staticRenderFns } from "./TabListAreaKoordinator.vue?vue&type=template&id=361734a1"
import script from "./TabListAreaKoordinator.vue?vue&type=script&lang=js"
export * from "./TabListAreaKoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports